/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { ShopperSearch } from '@/scapi';

/**
 * PLP-only product helpers (rating, tile description, variation group count).
 * Kept in a separate module so cart and other routes don't pull this code.
 */

export type ProductSearchHitLike = {
    productId?: string;
    productName?: string;
    shortDescription?: string;
    [key: string]: unknown;
};

const MOCK_RATING = { rating: 4, reviewCount: 218 };

export function getProductRating(_product: ProductSearchHitLike): { rating: number; reviewCount: number } {
    return MOCK_RATING;
}

export function getShortDescriptionFromSearchHit(
    product: ShopperSearch.schemas['ProductSearchHit'] | ProductSearchHitLike | undefined
): string | undefined {
    const text = product?.shortDescription?.trim();
    return text || undefined;
}

export function getVariationGroupCount(
    product: Pick<ShopperSearch.schemas['ProductSearchHit'], 'variationGroups'>
): number {
    return product.variationGroups?.length ?? 0;
}
